<template>
  <div class="text-sm mt-2 user-select-none" role="button" v-if="!updatingTask">
    Kolor czcionki
    <div>
      <div
        v-for="(color, index) in colors"
        :key="index"
        class="mx-1 px-1 d-inline border border-1"
        role="button"
        :style="`background-color: ${color};`"
        @click="updateTaskTextColor({ task: task, textColor: color })"></div>
    </div>
  </div>
  <div class="text-sm mt-2 user-select-none" v-if="!updatingTask">
    Kolor komórki
    <div>
      <div
        v-for="(color, index) in colors"
        :key="index"
        class="mx-1 px-1 d-inline border border-1"
        role="button"
        :style="`background-color: ${color};`"
        @click="updateTaskBackgroundColor({ task: task, date: date, backgroundColor: color })"></div>
    </div>
  </div>
  <div class="mt-2 text-center text-primary fw-bold" v-else>
    Trwa aktualizacja...
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import colors from '@/modules/cells/colors'
import { mapActions, mapGetters } from 'vuex'

export default defineComponent({
  name: 'TaskCellColorPicker',
  props: ['task', 'date'],
  data () {
    return {
      colors: colors
    }
  },
  computed: {
    ...mapGetters({
      updatingTask: 'calendarTask/getUpdatingTask'
    })
  },
  methods: {
    ...mapActions({
      updateTaskTextColor: 'calendarTask/updateTaskTextColor',
      updateTaskBackgroundColor: 'calendarTask/updateTaskBackgroundColor'
    })
  }
})
</script>
